import { useMemo } from "react";

import type { DropdownTab } from "@similarweb/ui-components";

import { SELECTED_ALL_PREFIX } from "../constants";

type HookParams<T> = {
    tabs: readonly DropdownTab<T>[];
    selectedAllCategory: Record<string, boolean>;
};

type HookValue = {
    tabsWithAllSelectedItems: readonly DropdownTab<unknown>[];
};

const useDropdownWithAllSelectedItems = <T>({ tabs, selectedAllCategory }: HookParams<T>): HookValue => {
    const { tabs: mappedTabs } = useMemo(() => {
        const modifiedTabs = tabs.map((tab) => {
            const selectedAllCategoryName = `${SELECTED_ALL_PREFIX} ${tab.name.trim().toLowerCase()}`;

            return {
                ...tab,
                items: [
                    {
                        name: selectedAllCategoryName,
                        isSelected: selectedAllCategory?.[selectedAllCategoryName],
                    },
                    ...tab.items,
                ],
            };
        });

        return {
            tabs: modifiedTabs,
        };
    }, [tabs, selectedAllCategory]);

    return {
        tabsWithAllSelectedItems: mappedTabs,
    };
};

export default useDropdownWithAllSelectedItems;
